<template>
  <div class="bg-white">
    <Aboutourservices />
    <div class="">
      <Caregiverexclusive />
      <ServicesInPartnership />
      <MembershipService />
      <!-- <ServiceWorkshop /> -->
    </div>
    <div class="">
      <ServicesFAQ />
    </div>
    <div class="bge3ceff-opa rounded-t-5555">
      <Footer />
    </div>
  </div>
</template>
<script>
import Reg2Service from "./components/Reg2Service.vue";
import MembershipService from "./components/MembershipService.vue";
import Aboutourservices from "./components/Aboutourservices.vue";
import Caregiverexclusive from "./components/Caregiverexclusive.vue";
import ServicesInPartnership from "./components/ServicesInPartnership.vue";
// import ServiceWorkshop from "./components/ServiceWorkshop.vue";
import ServicesFAQ from "./components/Service-FAQ.vue";
import Footer from "../Footer.vue";

export default {
  components: {
    Reg2Service,
    MembershipService,
    Aboutourservices,
    Caregiverexclusive,
    ServicesInPartnership,
    // ServiceWorkshop,
    ServicesFAQ,
    Footer,
  },
};
</script>
